module.exports = __webpack_public_path__ + "img/voice-icon1.2d52074.png";